import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import {
  tannerBlack,
  tannerGray,
  tannerSemantic,
  tannerWhite,
} from '../colors';

type MuiIconButton = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiIconButton'];
  defaultProps?: ComponentsProps['MuiIconButton'];
  variants?: ComponentsVariants['MuiIconButton'];
};

export const MuiIconButton: MuiIconButton = {
  defaultProps: {
    disableFocusRipple: true,
  },
  variants: [
    {
      props: { edge: 'end' },
      style: {
        marginRight: 0,
      },
    },
    {
      props: { size: 'small' },
      style: {
        height: 32,
        width: 32,
      },
    },
    {
      props: { color: 'default' },
      style: {
        color: '#000',
        '&.Mui-disabled': {
          color: tannerGray['400'],
        },
        '&:hover, &:focus-visible': {
          backgroundColor: tannerGray['100'],
        },
      },
    },
    {
      props: { color: 'white' },
      style: {
        color: '#000',
        backgroundColor: tannerWhite,
        '&.Mui-disabled': {
          color: '#000',
          backgroundColor: tannerGray['600'],
        },
        '&:hover, &:focus-visible': {
          backgroundColor: tannerGray['200'],
        },
      },
    },
    {
      props: { color: 'black' },
      style: {
        color: tannerWhite,
        backgroundColor: '#000',
        '&.Mui-disabled': {
          color: tannerWhite,
          backgroundColor: tannerGray['400'],
        },
        '&:hover, &:focus-visible': {
          color: tannerWhite,
          backgroundColor: tannerGray['800'],
        },
      },
    },
    {
      props: { color: 'info' },
      style: {
        color: tannerSemantic.info.color,
        backgroundColor: 'inherit',
        '&.Mui-disabled': {
          color: tannerSemantic.info.color,
          backgroundColor: tannerGray['400'],
        },
        '&:hover, &:focus-visible': {
          color: tannerSemantic.info['600'],
          backgroundColor: tannerSemantic.info.background,
        },
      },
    },
    {
      props: { color: 'error' },
      style: {
        color: tannerSemantic.error.color,
        backgroundColor: 'inherit',
        '&.Mui-disabled': {
          color: tannerSemantic.error.color,
          backgroundColor: tannerGray['400'],
        },
        '&:hover, &:focus-visible': {
          color: tannerSemantic.error['700'],
          backgroundColor: tannerSemantic.error.background,
        },
      },
    },
    {
      props: { color: 'success' },
      style: {
        color: tannerSemantic.success.color,
        backgroundColor: 'inherit',
        '&.Mui-disabled': {
          color: tannerSemantic.info.color,
          backgroundColor: tannerGray['400'],
        },
        '&:hover, &:focus-visible': {
          color: tannerSemantic.success['600'],
          backgroundColor: tannerSemantic.success.background,
        },
      },
    },
    {
      props: { color: 'warning' },
      style: {
        color: tannerSemantic.warning.color,
        backgroundColor: 'inherit',
        '&.Mui-disabled': {
          color: tannerSemantic.warning.color,
          backgroundColor: tannerGray['400'],
        },
        '&:hover, &:focus-visible': {
          color: tannerSemantic.warning['600'],
          backgroundColor: tannerSemantic.warning.background,
        },
      },
    },
  ],
  styleOverrides: {
    root: {
      color: '#000',
      borderRadius: 3,
      fontSize: 'inherit',
      height: 40,
      width: 40,
      transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:focus': {
        ':not(:focus-visible)': {
          outline: 'none',
          border: 'none',
        },
      },
      '&:focus-visible': {
        outline: `3px solid ${tannerSemantic.info.color}`,
        outlineOffset: 3,
        transition: 'outline-offset 150ms',
      },
      '&:hover, &:focus-visible': {
        backgroundColor: tannerGray['200'],
        color: tannerBlack,
      },
    },
  },
};
